import React from 'react';
import { useMsal } from '@azure/msal-react';
import { Avatar } from 'antd';
const UserIcon = () => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount();

  if (!account) {
    return null;
  }

  const { given_name: givenName, family_name: familyName, name } = account.idTokenClaims || {};

  const userName = name ?? `${givenName} ${familyName}`;

  const stringToHexColor = (name) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += ('00' + value.toString(16)).slice(-2);
    }

    return color;
  };
  const firstLetter = userName?.charAt(0).toUpperCase();

  return (
    <Avatar
      style={{
        backgroundColor: stringToHexColor(userName),
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      {firstLetter}
    </Avatar>
  );
};

export default UserIcon;
